import { render, staticRenderFns } from "./ReRegister.vue?vue&type=template&id=0c05e770&scoped=true&"
import script from "./ReRegister.vue?vue&type=script&lang=js&"
export * from "./ReRegister.vue?vue&type=script&lang=js&"
import style0 from "./ReRegister.vue?vue&type=style&index=0&id=0c05e770&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c05e770",
  null
  
)

export default component.exports